import { render, staticRenderFns } from "./ModuleOAuth2Connect.vue?vue&type=template&id=1f82ba28"
import script from "./ModuleOAuth2Connect.vue?vue&type=script&lang=js"
export * from "./ModuleOAuth2Connect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports